export default "__VITE_ASSET__BbWyghcv__"